import { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import styles from "./styles/ProductsCard.module.css";
import { fetchStripeProducts, pendingDiscount } from "../../Utils/StripeUtils";
import { UserData } from "../../Context/DataContext";
import useWindowDimensions from "../Footer/footer";
import Carousel from "../common/css/carousel";

export default function Products({
  selected,
  setSelected,
  currency,
  default_years = 3,
  isSubscriptionPage = false,
  subscPlan,
  /*
    The customer's promo code, so each card can show what they will actually
    save. ChoosePlan passes its own live coupon -- it already fetches the
    pending one and lets the customer type another, and the cards should follow
    both. Callers that pass nothing (Subscription's "add a plan") get the
    pending code fetched here instead, so the two pages agree.

    `undefined` means "not my business, go and look"; `null` means "I looked,
    there is none". ChoosePlan starts at null, which is why the distinction
    matters.
  */
  coupon,
}) {
  const choosedPlan = localStorage.getItem("registration_product");
  const userData = UserData();
  const [products, setProducts] = useState(null);
  const [error, setError] = useState();
  const { width } = useWindowDimensions();
  const [disableAllCards, setDisableAllCards] = useState(false);
  const [pendingCoupon, setPendingCoupon] = useState(null);

  const cardCurrency = currency
    ? currency.toLowerCase()
    : localStorage.getItem("language") === "fr"
    ? "eur"
    : "usd";
  const activeCoupon = coupon !== undefined ? coupon : pendingCoupon;

  /*
    Only when the caller did not hand us one. The currency goes with the
    request because a fixed-sum code is quoted per currency.
  */
  useEffect(() => {
    if (coupon !== undefined) return;
    let cancelled = false;
    pendingDiscount(cardCurrency)
      .then((res) => (res.status === 200 ? res.json() : null))
      .then((data) => {
        if (!cancelled && data?.code) setPendingCoupon(data);
      })
      .catch(() => {
        /* no badge boost is the right answer when we cannot tell */
      });
    return () => {
      cancelled = true;
    };
  }, [coupon, cardCurrency]);

  useEffect(() => {
    if (userData.products) {
      const products = userData?.products;
      const subscProduct = products.filter(
        (product) => subscPlan === product.id
      );
      if (subscProduct.length && subscProduct[0].name === "PAY AND FORGET") {
        setDisableAllCards(true);
        setSelected(null);
      } else {
        products.map((product) => {
          const isSubs = subscPlan === product.id;
          if (
            (product?.metadata?.years == choosedPlan ||
              product?.id === choosedPlan) &&
            !isSubs
          ) {
            setSelected(product);
          } else if (
            !choosedPlan &&
            product?.metadata?.years === default_years &&
            window?.location.pathname.includes("/user/plan")
          ) {
            setSelected(product);
          }
        });
      }
      setProducts(userData.products);
    } else {
      fetchStripeProducts().then((data) => {
        const subscProduct = data.products.filter(
          (product) => subscPlan === product.id
        );
        if (subscProduct.length && subscProduct[0].name === "PAY AND FORGET") {
          setDisableAllCards(true);
          setSelected(null);
        } else {
          data?.products.map((product) => {
            if (
              product?.metadata?.years == choosedPlan &&
              window?.location.pathname.includes("/user/plan")
            )
              setSelected(product);
          });
        }
        setProducts(data.products);
      });
    }
  }, []);

  return (
    <div>
      {width > 640 ? (
        <div className={styles.products_div}>
          {products &&
            products.map((product, index) => {
              let order = "1";
              if (product.metadata.years) {
                order = product.metadata.years;
              }

              const isSubs = subscPlan === product.id;

              return (
                <ProductCard
                  disableAllCards={disableAllCards}
                  isSubs={isSubs}
                  isSubscriptionPage={isSubscriptionPage}
                  key={product.id}
                  order={order}
                  currency={cardCurrency}
                  coupon={activeCoupon}
                  index={index + 1}
                  data={product}
                  OnClick={() => {
                    if (!isSubs) {
                      localStorage.setItem(
                        "registration_product",
                        product.metadata?.years
                      );

                      setSelected(product);
                    }
                  }}
                  selected={selected === product.id && !isSubs}
                />
              );
            })}
        </div>
      ) : products && !disableAllCards ? (
        <Carousel
          selected={products.findIndex((product) => product.id === selected)}
          items={products?.map((product, index) => {
            let order = "1";
            if (product.metadata.years) {
              order = product.metadata.years;
            }
            const isSubs = subscPlan === product.id;

            return (
              <ProductCard
                disableAllCards={disableAllCards}
                isSubs={isSubs}
                isSubscriptionPage={isSubscriptionPage}
                key={product.id}
                order={order}
                currency={cardCurrency}
                coupon={activeCoupon}
                index={index + 1}
                data={product}
                OnClick={() => {
                  localStorage.setItem(
                    "registration_product",
                    product.metadata?.years
                  );

                  setSelected(product);
                }}
                selected={selected === product.id}
              />
            );
          })}
        />
      ) : (
        products &&
        disableAllCards && (
          <Carousel
            selected={products.findIndex((product) => product.id === subscPlan)}
            items={products?.map((product, index) => {
              let order = "1";
              if (product.metadata.years) {
                order = product.metadata.years;
              }
              const isSubs = subscPlan === product.id;

              return (
                <ProductCard
                  disableAllCards={disableAllCards}
                  isSubs={isSubs}
                  isSubscriptionPage={isSubscriptionPage}
                  key={product.id}
                  order={order}
                  currency={cardCurrency}
                  coupon={activeCoupon}
                  index={index + 1}
                  data={product}
                  OnClick={() => {
                    localStorage.setItem(
                      "registration_product",
                      product.metadata?.years
                    );

                    setSelected(product);
                  }}
                  selected={selected === product.id}
                />
              );
            })}
          />
        )
      )}
      {error && <div style={{ color: "red" }}>{error}</div>}
    </div>
  );
}
